/* Add local storage for Year parameter Jan 21, 2023 */
/* Change remove Dashboard list component Aug 19, 2023 */
/* Move eyelash icon and add scoped Apr 13, 2024 */
/* Add dashboard dblClick Oct 25, 2025 */
<template lang="pug">
	div(id="kt-dashboard")
		div(class="kt-dashboard-header")
			b-dropdown(size="sm" variant="outline-secondary" )
				div(class="header-sticky")
					p(class="header-text") Select/Order Dashboard(s) to Display
						<fa-icon icon="times"  style="width: 0.4em;" @click="m_closeChildWindow" class="topright-close" />
					hr(style="border: none;")
				draggable(v-model="d_dashboards" handle=".btn-reorder-dashboard" swapThreshold=.1 animation=150  @end="m_saveUserSetting")
					div(class="dropdown-item" v-for ="db in d_dashboards" :key="db.id") 
						b-button(id="draggBtn" class="btn-reorder-cl-item" variant="none" title="Reorder dashboards")
							b-icon(icon="arrow-down-up" class="btn-reorder-dashboard")
						div(@click="m_toggleDB(db)")
							fa-icon(v-if="db.selected" icon="eye" style="color:blue;")
							fa-icon(v-else icon="eye-slash" style="color:#41b8d5;'")
							span(style="color:blue;") {{db.name}}
				template(v-slot:button-content) 
					|  Options
			
			slot(name="team-member-filter" :fCU="true" :fTM="d_canVD")
		b-container(class="kt-dashboard-content" fluid :class="c_tmFilter?'tm-filtered':null")
			div(v-for ="db in d_dashboards.filter(x=> x.selected)" :key="db.id" :class="'db kt-db-' + db.type"
				:style="{width:500, height:db.height}")
				div(v-if="db.type =='table'")
					kt-table(v-bind="db.KTProps" :p_tbInfo="db.desc" ref="kt-db-table")
					div(class="resizer-w" @mousedown="m_resizeDBTbl($event,db, 'w')" title="Resize width. Double click to reset")
					div(class="resizer-h" @mousedown="m_resizeDBTbl($event,db, 'h')" title="Resize height. Double click to reset")
				div( v-else-if="db.type =='chart'" )
					div(class="header")
						div
							span {{db.name}}
							kt-tt-info(:p_infoTxt="db.desc")
						div(v-if="db.hdrKey")
							b-form-select(v-if="db.hdrKey=='yr'" plain :options="d_opprYrs" :value="m_getChartLocalYear(db.id)||-1" @change="m_dbc_hdrYr(db, $event)")
						b-button(class="btn-cuFilter" :class="db.queryParams.currentUser?'filtered':null" variant="none"
							v-show="!db.queryParams.teamMemberId"
							v-b-tooltip.hover.auto.ds500="{title:'Filter My ' + db.scopeLabel}"
							@click="m_dbc_CurrUser(db)")
							//- fa-icon(:icon="db.queryParams.currentUser? 'user-check' : 'user-alt'")
							fa-layers
								fa-icon(icon="user-alt")
								fa-icon(:icon="['fas', 'filter']" transform="shrink-6 up-5 left-10" v-show="db.queryParams.currentUser")
						b-button(class="btn-refresh" variant="none" title="Refresh Chart" @click="m_dbc_Refresh(db)")
							fa-icon(icon="sync")
					//- Loading
					kt-spinner(v-if="db.loading")
					//- No Data/Error
					div(v-else-if="db.chrtMsg" class="chrtMsg") {{db.chrtMsg}}
					<small v-if="db.chartType === 'doughnut'">Hover over slice for more details.</small>
					canvas(class="DBChart" :id="'DBChart-' + db.id" :width="db.width||350" :height="db.height||200")
					//canvas(:id="'DBChart-' + db.id" :width="500" :height="db.height||200")
					div(class="footer" v-if="db.ftrKey")
						div(v-if="db.ftrKey=='mnth'" class="mnth")
							span(class="btn btn-link" @click="m_dbc_ftrMnth(db, -6)") Prev
							span(class="btn btn-link" @click="m_dbc_ftrMnth(db, +6)") Next
			div(v-if="d_dashboards.filter(x=> x.selected) == 0" class="none-selected")
				fa-icon(icon="tachometer-alt")
				p No Dashboards Selected
				div(class="small text-left")
					p The following dashboards are available for selection under the "Options" menu.
					ul
						li(v-for="db in d_dashboards" :key="db.id")
							b {{db.name}}
							span(v-if="db.desc") {{': ' + db.desc}}
			div(v-if="d_popupParams")
				kt-table-popup(v-bind="d_popupParams")
			</div>

</template>

 <script>
import {fn_getDashboardData} from "@/utils/api.js";
import util, {fn_resizeHelper, fn_taskCol_ActivityScope} from "@/utils/util.js";
import {refData, userSettings} from "@/utils/ref-data.js";
import KTTable from "@/components/Ctrl/KT-Table.vue";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";// eslint-disable-line
import 'chartjs-plugin-labels';
import {fn_getColumns as fn_getColumnsOppr} from "@/components/Nav/OpprNav.vue";
import {fn_getColumns as fn_getColumnsTask} from "@/components/Ctrl/KT-Tasks.vue";
import draggable from "vuedraggable";
import KTTablePopup from "@/components/Ctrl/KT-TablePopup.vue";
const const_bkp = {};
export default {
	name: "kt-dashboard",
	components: {
		"kt-table": KTTable,
		"kt-table-popup":KTTablePopup,
		draggable,
	},
	beforeCreate() {
		let kbdp = this.$parent;
		if (kbdp.d_cuFilter && kbdp.d_tmFilter) kbdp.d_tmFilter = null;
	},
	beforeDestroy() {
		let kbdp = this.$parent;
		if (!this.d_canVD && const_bkp.tm) {
			kbdp.d_tmFilter = const_bkp.tm;
		}
	},
	created() {
		this.d_canVD = userSettings.permissions.VTMD === true;
		let kbdp = this.$parent;
		if (!this.d_canVD && kbdp.d_tmFilter) {
			const_bkp.tm = kbdp.d_tmFilter;
			kbdp.d_tmFilter = null;
		}

		fn_ChartSettings();
		fn_prepDashboards(this);

		fn_getDashboardData({}).then(resp => {
			(resp.refData.opprYrs || []).forEach(x => {
				this.d_opprYrs.push({text: x.yr, value: x.yr});
			});
		});
	},
	mounted() {  
		fn_renderCharts(this, null);
	},
	data() {
		return {
			d_canVD: null,
			d_dashboards: [],
			d_refSkip: null,
			d_opprYrs: [{text: 'All Years', value: -1}],
			d_chartYear:null,
			d_popupParams:null,
		};
	},
	props: {},
	computed: {
		c_cuFilter() {
			return this.$parent.d_cuFilter;
		},
		c_tmFilter() {
			return this.$parent.d_tmFilter;
		},
		c_dbCurrUsrCnt() {
			return this.d_dashboards.filter(db => db.selected && db.queryParams.currentUser).length;
		}
	},
	methods: {
		m_toggleDB(db) {
			db.selected = !db.selected;

			if (db.selected && db.type == 'chart') {
				setTimeout(() => {fn_renderCharts(this, db);}, 300);
			}
			this.m_saveUserSetting();

		},
		m_saveUserSetting() {

			let val = this.d_dashboards.filter(x => x.selected).map((x, ix) => ({
				id: x.id,
				width: x.width,
				height: x.height,
				name:x.name
			}));
			val.forEach((x,ix)=>{
				x.order=ix;
				});
			
			console.log('selected');
			console.log(val);
			util.fn_saveUserOpts('dashboardsSelected', null, val);
		},
		m_resizeDBTbl(e, db, wh) {
			if (e.button != 0) return;
			if (e.detail > 1) {
				//Double click = Reset Width to "Auto"
				if (wh == 'w') db.width = null;
				else db.height = null;
				//No need to call m_saveUserSetting. First mouse up will save it.
				return;
			}
			let $resizer = $(e.target);
			let $tgtElem = $resizer.closest('div.db');
			let width = wh != 'w' ? null : {
				min: 300,
				max: $resizer.closest('div.kt-dashboard-content')[0].offsetWidth - 5,
				newW: null,//set by resizer util
			};
			let height = wh != 'h' ? null : {
				min: 250,
				max: 800,
				newH: null,//set by resizer util
			};
			fn_resizeHelper($resizer, $tgtElem, width, height).then(() => {
				if (wh == 'w') {
					if (db.width == width.newW || !width.newW) return;
					db.width = width.newW;
				}
				else {
					if (db.height == height.newH || !height.newH) return;
					db.height = height.newH;
				}

				this.m_saveUserSetting();
			});
		},

		m_dbc_CurrUser(dbChart) {
			let qp = dbChart.queryParams;
			qp.currentUser = !qp.currentUser;
			qp.teamMemberId = null;
			fn_renderCharts(this, dbChart);
		},
		m_dbc_Refresh(dbChart) {
			fn_renderCharts(this, dbChart, true);
		},
		m_db_refreshAll() {
			let cu = this.c_cuFilter || null;
			let tmId = (this.c_tmFilter || {}).teamMemberId || null;

			this.d_dashboards.forEach(db => {
				db.queryParams.currentUser = cu;
				db.queryParams.teamMemberId = tmId;
			});
			fn_renderCharts(this, null);
			let tbls = this.$refs['kt-db-table'] || [];
			tbls.forEach(ktt => ktt.m_getData(true));
		},
		m_dbc_ftrMnth(dbChart, pn) {
			let qp = dbChart.queryParams;
			qp.mnthPrd = (qp.mnthPrd || 0) + pn;
			fn_renderCharts(this, dbChart, false);
		},
		m_dbc_hdrYr(dbChart, e) {
			let qp = dbChart.queryParams;
			qp.year = e == -1 ? null : e;
			
			window.localStorage.setItem('chart'+dbChart.id+'Year',e);
			
			fn_renderCharts(this, dbChart, false);
		},
		m_getChartLocalYear(chartId){
			var chartLocalYear=window.localStorage.getItem('chart'+chartId+'Year');
			//if(parseInt(chartLocalYear)==-1) chartLocalYear=null;
			return chartLocalYear?parseInt(chartLocalYear):null;
		},
		m_closeChildWindow(){
			document.getElementsByClassName("DBChart")[0].click();
		},

	},
	watch: {
		'$parent.c_cutmKey'(nv, ov) {
			if (this.d_refSkip) this.d_refSkip = null;
			else this.m_db_refreshAll();
		},
		c_dbCurrUsrCnt(nv, ov) {
			let cu = this.c_cuFilter;
			let sel = this.d_dashboards.filter(x => x.selected).length;
			if (cu && nv != sel) {
				this.d_refSkip = true;
				this.$parent.d_cuFilter = null;
			}
			else if (!cu && nv == sel) {
				this.d_refSkip = true;
				this.$parent.d_cuFilter = true;
			}
		}
	}
};

// have a separate option object for the char type 
// create a function to pass argument and that function return the options needed
function chartOptions(chartType, dataset, chartOptions) {
	let options = {
		type: chartType,
		data: dataset,
		options: chartOptions,

	}

	return options;
}

function fn_ChartSettings() {
	Chart.Tooltip.positioners.center = (elements) => {
		const {x, y, base} = elements[0]._model;
		const height = base - y;
		return {x, y: y + (height / 2)};
	};
}
function fn_prepDashboards(vc) {
	let usrOpt = userSettings.userOptions.dashboardsSelected || [];
	let cu = vc.c_cuFilter || null;
	let tmId = (vc.c_tmFilter || {}).teamMemberId || null;

	let dbs = refData.dashboards.map(function(db) {
		let uo = usrOpt.filter(x => x.id == db.id)[0] || {};
		let chartYear=fn_getChartLocalYear(db.id);
		vc.d_chartYear=chartYear;
		if(uo.id) console.log(db.name+':'+uo.order);
		return {
			id: db.id,
			name: db.name,
			desc: db.desc,
			selected: uo.id ? true : false,
			order: uo.order,
			type: [3, 4, 5, 7, 8,11,12].indexOf(db.id) > -1 || db.id > 20  ? 'chart' : 'table',
			loading: null,
			chrtMsg: null,
			queryParams: {dashboardId: db.id, currentUser: cu, teamMemberId: tmId, year:chartYear},
			width: uo.width,
			height: uo.height,
			backgroundColors: db.backgroundColors,
			chartType: db.chartType,
			keyLabels: db.keyLabels,
			scopeLabel: [3, 4, 5, 7,9,11,12].indexOf(db.id) > -1 || db.id > 20 ? 'Opportunities' : [8].indexOf(db.id) > -1 ? 'Activities' : null,
			category:db.category,
			vgtSelected:uo.id ? true : false,
			dbColumn:db.dbcolumn,
			dbFilter:db.dbfilter,
		};
	});


vc.d_dashboards = fn_sortList(dbs);


	


	let getdb = (id) => {return dbs.filter(x => x.id == id)[0];};

	//must call after d_dashboard is set
	fn_setDashboardProps_Tables(vc, getdb);
	fn_setDashboardProps_Charts(vc, getdb);
}

function fn_setDashboardProps_Tables(vc, getdb) {
   //let dbs = vc.d_dashboards;
   
	// Oppr Tables
	let oppr_ktOpts = {
		detailView: false,
		// staticHeight: 180,
		pageSize: 5,
		enableSearch: false,
		enableCUFilter: true,
		openLinksInModal: true,
	};
	let oppr_ktCols = fn_getColumnsOppr().filter(x => x.__dbvw);
	oppr_ktCols.forEach(x => {
		delete x.__dbvw;
	});

	let db1 = getdb(1);
	db1.faIcon = 'table';
	db1["KTProps"] = {
		p_appEntKey: "oppr",
		p_tblIdKey: "-dashboardId-1",
		p_opts: oppr_ktOpts,
		p_cols: oppr_ktCols,
		p_tbNote: db1.name,
		p_qryPrms: db1.queryParams,
		p_getDataFn: fn_getDashboardData,
	};

	let db2 = getdb(2);
	db2.faIcon = 'table';
	db2["KTProps"] = {
		p_appEntKey: "oppr",
		p_tblIdKey: "-dashboardId-2",
		p_opts: oppr_ktOpts,
		p_cols: oppr_ktCols,
		p_tbNote: db2.name,
		p_qryPrms: db2.queryParams,
		p_getDataFn: fn_getDashboardData
	};


	// Task Table
	let task_ktOpts = {
		detailView: false,
		// staticHeight: 180,
		pageSize: 5,
		enableSearch: false,
		enableCUFilter: true,
		openLinksInModal: true,
	};
	let task_ktCols = fn_getColumnsTask().filter(x => x.__dbvw);
	task_ktCols.forEach(x => {
		x.field = x.key;
		if (x.editOnClick) {
			x.linkFn = (col, row) => {return {prntType: row.prntType, id: row.taskId};};
		}
		['key', '__dbvw', 'hideInForm', 'icon', 'iconFn', 'editOnClick'].forEach(k => delete x[k]);
	});
	task_ktCols.unshift(fn_taskCol_ActivityScope());

	let db6 = getdb(6);
	db6.faIcon = 'table';
	db6["KTProps"] = {
		p_appEntKey: 'task',
		p_tblIdKey: "-dashboardId-6",
		p_opts: task_ktOpts,
		p_cols: task_ktCols,
		p_tbNote: db6.name,
		p_qryPrms: db6.queryParams,
		p_getDataFn: fn_getDashboardData
	};
	
// Define Dashboard columns. Need to be on a separate file.	
 let tableColumns=[
{key:"client",
field:"client",
label:"Client",
title:"Client",
default:true,
visible:true,
length:50,
sortable:false
},
{key:"proposalCost",
field:"proposalCost",
label:"Amount spent on proposals",
title:"Amount spent on proposals",
default:true,
visible:true,
length:15,
sortable:false,
class:"text-warning",
datatype: 'num',
valFmtFn: val => util.fn_fmtMoney(val)
},
{key:"submitted",
field:"submitted",
default:true,
label:"Proposals Submitted",
title:"Proposals Submitted",
visible:true,
length:5,
sortable:false
},
{key:"amountSubmitted",
field:"amountSubmitted",
default:true,
label:"Value Submitted",
title:"Value Submitted",
visible:true,
length:5,
sortable:false,
showAggr: 'sum',
datatype: 'num',
valFmtFn: val => util.fn_fmtMoney(val)
},
{key:"awarded",
field:"awarded",
default:true,
label:"Awarded",
title:"Awarded",
visible:true,
length:5,
sortable:false,
class:"text-success"
},
{key:"amountAwarded",
field:"amountAwarded",
label:"Value Awarded",
title:"Value Awarded",
default:true,
visible:true,
length:15,
sortable:false,
class:"text-success",
datatype: 'num',
valFmtFn: val => util.fn_fmtMoney(val)
},
{key:"pending",
field:"pending",
label:"Pending",
title:"Pending",
default:true,
visible:true,
length:5,
sortable:false,
datatype: 'num',
class:"text-info"
},
{key:"amountPending",
field:"amountPending",
label:"Value Pending",
title:"Value Pending",
default:true,
visible:true,
length:15,
sortable:false,
class:"text-info",
datatype: 'num',
valFmtFn: val => util.fn_fmtMoney(val)
},
{key:"notAwarded",
field:"notAwarded",
label:"Not Awarded",
title:"Not Awarded",
default:true,
visible:true,
length:5,
sortable:false,
class:"text-danger",
datatype: 'num'
},
{key:"amountNotAwarded",
field:"amountNotAwarded",
label:"Value Not Awarded",
title:"Value Not Awarded",
default:true,
visible:true,
length:15,
sortable:false,
class:"text-danger",
datatype: 'num',
valFmtFn: val => util.fn_fmtMoney(val)
}
 ];
 
 
	let db9 = getdb(9);
	db9.faIcon = 'table';
	db9["KTProps"] = {
		p_appEntKey: 'oppr',
		p_tblIdKey: "-dashboardId-9",
		p_opts: oppr_ktOpts,
		p_cols: tableColumns,
		p_tbNote: db9.name,
		p_qryPrms: db9.queryParams,
		p_getDataFn: fn_getDashboardData
	};

 

}


function fn_setDashboardProps_Charts(vc, getdb) {
	// Chart Colors
	let cc = {


		b3: '#a1cbc9',
		bb1: '#0a0e29',
		bb2: '#2d325a',
		bb3: '#304b78',
		
		c1:'#2d8bba',
		c2:'#2f5f98',
		c3:'#31356e',
		c4:'#4076ba',
		c5:'#41b8d5',
		c6:'#6ce5e8',
		



		y3: '#ecbc8b',


		r3: '#d3523f',
		r4: '#69322f',


		o3: '#f38419',
		o4: '#eda92c',

		// g1: 'rgba(41, 168, 71,.5)',
		g2: '#7aa039',
		g3: '#0a2e20',
		g4: '#034c5d',




		gr5: "rgb(173, 181, 189)",

		bg1: "rgba(108, 117, 125)",
		bg2: "rgba(255, 255, 255,.8"
	};

	let db3 = getdb(3);
	db3.faIcon = 'chart-bar';
	db3.hdrKey = 'yr';
	db3["CJSProps"] = {
		type: "horizontalBar",
		data: {
			labels: ["Opportunities"],
			datasets: [
				{label: "Awarded Secured", backgroundColor: [cc.c1]},
				{label: "Awarded Not Yet Secured", backgroundColor: [cc.c2]},
				{label: "Remaining Pending", backgroundColor: [cc.c3]}
			]
		},
		options: {
			responsive: false,
			legend: {display: true, position: "bottom", align: "start"},
			tooltips: {
				enabled: true,
				mode: "point",
				// xAlign: 'middle',
				callbacks: {
					beforeTitle: () => {
						return db3.currentUser ? '(Current User)' : null;
					},
					label: (tti, c) => {
						// let di = tti.datasetIndex;

						let ds = c.datasets[tti.datasetIndex];
						let val = tti.value;
						let d = [];
						c.datasets.forEach(x => {d.push(x.data[0]);});
						let pct = util.fn_calcPct(d, val);
						return ds.label + ": " + util.fn_fmtMoney(val) + ' (' + pct + ')';
					}
				}
			},
			plugins: {
				datalabels: {
					labels: {
						value: {
							formatter: (val, cntx) => {return val == 0 ? null : util.fn_fmtMoney(val, true);},
							anchor: "center",
							align: "end",
							color: "#fff",
							backgroundColor: cc.bg1,
							borderRadius: 3,
							padding: {bottom: 1}
						},
						pct: {
							formatter: (val, cntx) => {
								let d = [];
								cntx.chart.config.data.datasets.forEach(x => {d.push(x.data[0]);});
								return util.fn_calcPct(d, val);
							},
							display: 'auto',
							anchor: "start",
							align: "end",
							backgroundColor: cc.bg2,
							borderRadius: 3,
							padding: {bottom: 1},

						},
					}
				}
			},

			datasets: {
				horizontalBar: {
					categoryPercentage: 1,
					barPercentage: 0.95
				}
			},
			scales: {
				offset: false,
				xAxes: [
					{
						ticks: {display: false, beginAtZero: true},
						gridLines: {display: false}
					}
				],
				yAxes: [
					{
						type: "category",
						ticks: {display: false},
						gridLines: {display: false}
					}
				]
			}
		},

		_fn_data: function(ds) {
			let dds = this.data.datasets;
			dds[0].data = [ds.AwardedSecured || 0];
			dds[1].data = [ds.AwardedNotSecured || 0];
			dds[2].data = [ds.RemainingPening || 0];
		}
	};


		let db4 = getdb(4);
	db4.faIcon = 'chart-pie';
	db4.hdrKey = 'yr';
	db4["CJSProps"] = {
		type: "doughnut",
		data: {
			labels: ["Wins", "Losses"],
			datasets: [
				{
					label: "Value of Opportunities",
					backgroundColor: [cc.c1,cc.c2],  //[cc.b3, cc.r3],
					borderWidth: 5,
					hoverBorderWidth: 1,
					weight: 6
				}
			]
		},
		options: {
			responsive: false,
			legend: {
				display: false
			},
			cutoutPercentage: 30,
			tooltips: {
				enabled: true,
				mode: "point",
				callbacks: {
					title: (item, data) => {
						let title = data.labels[item[0].index];

						return `${title}`;
					},
					label: (tooltipItem, data) => {
						let result = '';
						let val = data.datasets[0].data[tooltipItem.index];

						if(val || val === 0 || isNaN(val)) {
							result += util.fn_fmtMoney(val);
						}
					
						return result;
					}
				}
			},
			plugins: {
				labels: [
					{
						render: (context) => {
							let labels = context.label.split(' ');
							let label = labels.length > 1 ? labels[0]+'...' : labels[0];

							if(context.percentage < '5') {
								return '';
							} else {
								if(context.label.length <= '15') {
									return `${context.label} ${context.percentage}%`;
								} else {
									return `${label} ${context.percentage}%`;
								}
							}
						},
						showZero: false,
						fontSize: 10,
						position: 'outside',
						textMargin: 4,
					}
				],
				datalabels: {
					opacity: 0,
				}
			}
		},
		_fn_data: function(ds) {
			let dsData = this.data.datasets;
			dsData[0].data = [ds.AwardedValue, ds.NotAwardedValue];
			/* dsData[1].data = [ds.AwardedCount, ds.NotAwardedCount]; */
		},

	};


	let db5 = getdb(5);
	db5.faIcon = 'chart-pie';
	db5.hdrKey = 'yr';
	db5["CJSProps"] = {
		type: "doughnut",
		data: {
			labels: ["Sales Pipeline"],
			datasets: [
				{
					backgroundColor: ['#2d8bba','#2f5f98','#31356e','#4076ba','#41b8d5','#6ce5e8'],                                  //[cc.y3, cc.bb3, cc.r3, cc.b3, cc.o3, cc.g2],
					borderWidth: 5,
					hoverBorderWidth: 1
				}
			]
		},
		options: {
			responsive: false,
			legend: {
				display: false
			},
			cutoutPercentage: 30,
			tooltips: {
				enabled: true,
				mode: "point",
				callbacks: {
					title: (item, data) => {
						let title = data.labels[item[0].index];

						return `${title}`;
					},
					label: (tooltipItem, data) => {
						let result = '';
						let val = data.datasets[0].data[tooltipItem.index];

						if(val || val === 0 || isNaN(val)) {
							result +=  util.fn_fmtMoney(val);
						}

						return result;
					}
				}
			},
			plugins: {
				labels: [
					{
						render: (context) => {
							let labels = context.label.split(' ');
							let label = labels.length > 1 ? labels[0]+'...' : labels[0];

							if(context.percentage < '5') {
								return '';
							} else {
								if(context.label.length <= '15') {
									return `${context.label} ${context.percentage}%`;
								} else {
									return `${label} ${context.percentage}%`;
								}
							}
						},
						showZero: false,
						fontSize: 10,
						position: 'outside',
						textMargin: 4,
					}
				],
				datalabels: {
					opacity: 0,
				}
			}
		},
		_fn_data: function(ds) {
			this.data.labels = [];

			let dsd = this.data.datasets[0].data = [];

			Object.keys(ds).forEach(k => {
				this.data.labels.push(k);
				dsd.push(ds[k] || 0);
			}, this);
		}
	};
	
	

	let db7 = getdb(7);
	db7.faIcon = 'chart-bar';
	db7.ftrKey = "mnth";
	db7["CJSProps"] = {
		type: "bar",
		data: {
			labels: [],
			datasets: [
				{label: "Value Total"},
				{label: "# of Opportunities", hidden: true},
			]
		},
		options: {
			responsive: false,
			legend: {display: false, position: "bottom", align: "start"},
			tooltips: {
				enabled: true,
				mode: "point",
				position: 'center',
				callbacks: {
					beforeTitle: () => {
						return db7.currentUser ? '(Current User)' : null;
					},
					label: (tti, c) => {
						let ds = c.datasets[1];
						return ds.label + ': ' + ds.data[tti.index];
					}
				}
			},
			plugins: {
				datalabels: {
					labels: {
						value: {
							formatter: (val, cntx) => {return util.fn_fmtMoney(val);},
							anchor: "end",
							align: 'start',
							clip: true,
							color: "#fff",
							backgroundColor: cc.c1,
							borderRadius: 3,
							padding: {bottom: 1}
						},
					}
				}
			},

			datasets: {
				bar: {
					categoryPercentage: 1,
				}
			},
			scales: {
				offset: false,
				xAxes: [
					{
						ticks: {display: true, fontSize: 11},
						gridLines: {display: false},
					},

				],
				yAxes: [
					{
						ticks: {display: false, beginAtZero: true},
						gridLines: {display: true}
					}
				]
			}
		},

		_fn_data: function(ds) {

			let lbls = this.data.labels = [];
			let dsData = this.data.datasets[0].data = [];
			let dsBgc = this.data.datasets[0].backgroundColor = [];
			let dsData2 = this.data.datasets[1].data = [];

			ds.forEach((x, ix) => {
				lbls.push(x.mnth);
				dsData.push(x.val);
				dsBgc.push(ix == 0 ? cc.c2 : cc.c3);
				dsData2.push(x.cnt);
			}, this);
		}
	};


	let db8 = getdb(8);
	db8.faIcon = 'chart-bar';
	db8.ftrKey = "mnth";
	db8["CJSProps"] = {
		type: "bar",
		data: {
			labels: [],
			datasets: []
		},
		options: {
			responsive: false,
			legend: {display: true, position: "bottom", align: "start"},
			tooltips: {
				enabled: true,
				mode: "point",
				position: 'center',
				callbacks: {
					beforeTitle: () => {
						return db8.currentUser ? '(Current User)' : null;
					},
					title: (tti, c, x) => {
						let i = tti[0];
						let d = c.datasets.map(x => x.data[i.index]);
						let s = util.fn_calcSum(d);
						return i.label + ', ' + s + ' Activit' + (s == 1 ? 'y' : 'ies');
					}
				}
			},
			plugins: {
				datalabels: {
					labels: {
						value: {
							formatter: (val, cntx) => {return val || null;},
							anchor: "center",
							// clip: true,
							color: "#fff",
							backgroundColor: cc.c1,
							borderRadius: 3,
							padding: {bottom: 1}
						},
					}
				}
			},

			datasets: {
				bar: {
					categoryPercentage: 1,
				}
			},
			scales: {
				offset: false,
				xAxes: [
					{
						ticks: {display: true, fontSize: 11},
						gridLines: {display: false},
						stacked: true
					},

				],
				yAxes: [
					{
						ticks: {display: false, beginAtZero: true},
						gridLines: {display: true},
						stacked: true

					}
				]
			}
		},

		_fn_data: function(ds) {

			let lbls = this.data.labels = [];
			let dsCJS = this.data.datasets = [
				{label: "To Do", backgroundColor: cc.c1, data: []},
				{label: "In Progress", backgroundColor: cc.c2, data: []},
				{label: "Completed", backgroundColor: cc.c3, data: []}
			];

			ds.forEach(dsItem => {
				lbls.push(dsItem.mnth);

				dsCJS.forEach(x => {
					let val = dsItem[x.label];
					x.data.push(val);
				});
			}, this);
		}
	};
	
	
	

	
	let db11 = getdb(11);
	db11.faIcon = 'chart-pie';
	db11["CJSProps"]={};
	db11.hdrKey = 'yr';
	let db21 = getdb(21);
	db21.faIcon = 'chart-pie';
	db21["CJSProps"]={};
	db21.hdrKey = 'yr';
	let db22 = getdb(22);
	db22.faIcon = 'chart-pie';
	db22["CJSProps"]={};
	db22.hdrKey = 'yr';
	let db23 = getdb(23);
	db23.faIcon = 'chart-pie';
	db23["CJSProps"]={};
	db23.hdrKey = 'yr';
    let db24 = getdb(24);
	db24.faIcon = 'chart-pie';
	db24["CJSProps"]={};
	db24.hdrKey = 'yr';
	let db25 = getdb(25);
	db25.faIcon = 'chart-pie';
	db25["CJSProps"]={};
	db25.hdrKey = 'yr';
	let db26 = getdb(26);
	db26.faIcon = 'chart-pie';
	db26["CJSProps"]={};
	db26.hdrKey = 'yr';
	let db27 = getdb(27);
	db27.faIcon = 'chart-pie';
	db27["CJSProps"]={};
	db27.hdrKey = 'yr';
	let db28 = getdb(28);
	db28.faIcon = 'chart-pie';
	db28["CJSProps"]={};
	db28.hdrKey = 'yr';
	let db29 = getdb(29);
	db29.faIcon = 'chart-pie';
	db29["CJSProps"]={};
	db29.hdrKey = 'yr';
	let db30 = getdb(30);
	db30.faIcon = 'chart-pie';
	db30["CJSProps"]={};
	db30.hdrKey = 'yr';
	let db31 = getdb(31);
	db31.faIcon = 'chart-pie';
	db31["CJSProps"]={};
	db31.hdrKey = 'yr';
	let db32 = getdb(32);
	db32.faIcon = 'chart-pie';
	db32["CJSProps"]={};
	db32.hdrKey = 'yr';
	let db33 = getdb(33);
	db33.faIcon = 'chart-pie';
	db33["CJSProps"]={};
	db33.hdrKey = 'yr';
    let db34 = getdb(34);
	db34.faIcon = 'chart-pie';
	db34["CJSProps"]={};
	db34.hdrKey = 'yr';
	let db35 = getdb(35);
	db35.faIcon = 'chart-pie';
	db35["CJSProps"]={};
	db35.hdrKey = 'yr';
	let db36 = getdb(36);
	db36.faIcon = 'chart-pie';
	db36["CJSProps"]={};
	db36.hdrKey = 'yr';
	let db37 = getdb(37);
	db37.faIcon = 'chart-pie';
	db37["CJSProps"]={};
	db37.hdrKey = 'yr';
	let db38 = getdb(38);
	db38.faIcon = 'chart-pie';
	db38["CJSProps"]={};
	db38.hdrKey = 'yr';
	let db39 = getdb(39);
	db39.faIcon = 'chart-pie';
	db39["CJSProps"]={};
	db39.hdrKey = 'yr';
	let db40 = getdb(40);
	db40.faIcon = 'chart-pie';
	db40["CJSProps"]={};
	db40.hdrKey = 'yr';
	
	

}


function fn_renderCharts(vc, dbChart, isRefresh) {
	let dbCharts = [dbChart];


	if (!dbChart) dbCharts = vc.d_dashboards.filter(x => x.type == 'chart');
	


	dbCharts.forEach(dbc => {
		let dbColumn=dbc.dbColumn;
		let dbFilter =dbc.dbFilter?dbc.dbFilter:null;
	
		if (!dbc.CJSProps || dbc.loading) return;

		if (dbc.chartObj) dbc.chartObj.destroy();
		
		
		let ctx = $(vc.$el).find("#DBChart-" + dbc.id)[0];
		

		if (!ctx) return;

		let reqPrms = {...dbc.queryParams};
		console.log('queryParams');
		console.log(reqPrms);

		if (isRefresh === true) reqPrms.refresh = true;

		dbc.loading = true;

		fn_getDashboardData(reqPrms).then(resp => {
			if (resp.error) {
				dbc.loading = null;
				dbc.chrtMsg = 'Unable to load chart.' + resp.error || '';
				return;
			}

            if (!resp.datasets) { 
				dbc.nodata = true;
				dbc.loading = null;
				dbc.chrtMsg = 'No Data Found';
				return;
			}
    
            if ( dbc.id <= 8 ) {
				//Get the id any id from 1 up to 8
				let ds = resp.datasets;
				dbc.CJSProps._fn_data(ds);
				dbc.chartObj = new Chart(ctx, dbc.CJSProps);
				dbc.loading = null;
				let dss = dbc.CJSProps.data.datasets;
				let noData = dss.map(x => x.data).filter(x => x.filter(x2 => x2 > 0).length > 0).length == 0;
				dbc.chrtMsg = noData ? 'No Data Found' : null;
				
				var chart=dbc.chartObj;
				var canvas = document.getElementById('DBChart-' + dbc.id);
				canvas.addEventListener('dblclick', (event) => {fn_tablePopup(event,vc,dbc);});
				
			}
			else {
				dbc.chrtMsg=null;
				// New method Get and use Chart Type, Background Colors, Labels, etc from the database			 
				let legendPosition=(dbc.chartType=='pie'? "right":"bottom");
				let xValues = [];
				let yValues = [];
				let bColors = [];
				let v_dataset ={};
				let chartDataSet=[];
				let v_ArrayDataset=[];
				let yFormattedValues = [];
				let chartType;
				let DBColors = [];
				DBColors = dbc.backgroundColors?dbc.backgroundColors.split(','):null;
				let formatValue=false;
				//let dbColumn=dbc.dbColumn;
				//let dbFilter =dbc.dbFilter?dbc.dbFilter.replace("=",":"):null;
				//let dbFilter =dbc.dbFilter?dbc.dbFilter:null;
				

				let chartTooltip = {
					enabled: true,
					mode: "point",
					callbacks: {
						label: (tti, c) => {
							let val = tti.value;
							let ds = c.datasets[0];
							let label = c.labels[tti.index]
							switch (dbc.id) {
								case 12:
									return util.fn_fmtMoney(val);
								case 9:
									var dstLabel = c.datasets[tti.datasetIndex].label;
									return dstLabel + ': ' + val;
								default:
									return label + ': ' + ds.data[tti.index];
							}
						}
					}
				}
				let optionsObject = {}
				
				resp.datasets.forEach((row,rIndex) =>{
					xValues.push(row.xValue);
					yValues.push(row.yValue);
					if(row.formattedValue) {
					yFormattedValues.push(row.formattedValue);
					formatValue=true;}
					if(row.bColor) DBColors[rIndex]=row.bColor;
					if(DBColors) bColors.push(DBColors[rIndex]||DBColors[0]); //must provide at least one background color
				});

				switch (dbc.chartType) {
					case 'Stacked horizontalBar':
						{
						var listString=null;

						for (var y = 0; y < yValues[0].split(",").length; y++) {
							for (var x = 0; x < xValues.length; x++) {
								if(x==0) listString=yValues[x].split(",")[y]
								else listString=listString+','+yValues[x].split(",")[y];
							}
							v_ArrayDataset=listString.split(",");
							v_dataset={label:dbc.keyLabels.split(",")[y],
							backgroundColor: bColors[y],
							data:v_ArrayDataset
							};
							chartDataSet.push(v_dataset);
						}

						let barDataOptions =  {
							labels: xValues,
							datasets: chartDataSet,
							formattedValues: yFormattedValues,
							formatData: formatValue
						};

						let barChartOptions = {
							legend: { display: true, position: legendPosition, labels: { fontSize: 14 } }, 
							tooltips: chartTooltip,
							plugins: {
								datalabels: {
									formatter: function (value, context) {
										if (dbc.id == 12) return util.fn_fmtMoney(value)
										else return value;
									},
									color: 'white',
									textAlign: 'center',
									font: {
										lineHeight: 1.6
									}
								}
							},
							scales: {
								xAxes: [{
									ticks: {
										color: 'blue', display: false, beginAtZero: true,
									},
									gridLines: { display: false },
									stacked: true
								}],
								yAxes: [{
									stacked: true,
									ticks: {
										callback: function (label, index, labels) { return label; }
									}
								}]
							}
						}

						optionsObject = chartOptions('horizontalBar', barDataOptions, barChartOptions)
						break;
						}
					case 'doughnut':
					case 'pie':
					{
						v_dataset = {
							label: dbc.keyLabels,
							backgroundColor: bColors,
							data: yValues,
							borderWidth: 5,
							hoverBorderWidth: 1,
							weight: 6
						};

						chartDataSet.push(v_dataset);

						let doughnutDataOptions = {
							labels: xValues,
							datasets: chartDataSet
						};

						let doughnutChartOptions = {
							legend: { 
								display: false 
							},
							tooltips: {
									enabled: true,
									mode: "point",
									callbacks: {
										title: (item, data) => {
											let title = data.labels[item[0].index];

											return `${title}`;
										},
										label: (tooltipItem, data) => {
											let result = '';
											let val = data.datasets[0].data[tooltipItem.index];

											if(val || val === 0 || isNaN(val)) {
												result += util.fn_fmtMoney(val);
											}

											return result;
										}
									}
							},
							cutoutPercentage: 30,
							plugins: {
								labels: [
									{
										render: (context) => {
											let labels = context.label.split(' ');
											let label = labels.length > 1 ? labels[0]+'...' : labels[0];

											if(context.percentage < '5') {
												return '';
											} else {
												if(context.label.length <= '15') {
													return `${context.label} ${context.percentage}%`;
												} else {
													return `${label} ${context.percentage}%`;
												}
											}
										},
										showZero: false,
										fontSize: 10,
										position: 'outside',
										textMargin: 4,
									}
								],
								datalabels: {
									opacity: 0,
								}
							}
						}

						optionsObject = chartOptions('doughnut', doughnutDataOptions, doughnutChartOptions)
						break;
						}
					default:
					{
						v_dataset = {
							label:dbc.keyLabels,
							backgroundColor: bColors,
							data:yValues,
							font: {size: 20, color:"#FFFFFF"}
						};

						chartDataSet.push(v_dataset);

						let defaultDataOptions = {
							labels: xValues,
							datasets: chartDataSet,
							formattedValues: yFormattedValues,
							formatData: formatValue
						};

						let defaultChartOptions = {
							legend: { display: true, position: legendPosition, labels: { fontSize: 14 } },
							tooltips: chartTooltip,
							plugins: {
								datalabels: {
									formatter: function (value, context) {
										if (dbc.id == 12) return util.fn_fmtMoney(value)
										else return value;
									},
									color: 'white',
									textAlign: 'center',
									font: {
										lineHeight: 1.6
									}
								}
							},
							scales: {
								xAxes: [{
									ticks: {
										color: 'blue', display: false, beginAtZero: true,
									},
									gridLines: { display: false },
									stacked: true
								}],
								yAxes: [{
									stacked: true,
									ticks: {
										callback: function (label, index, labels) { return label; }
									}
								}]
							}
						}

						optionsObject = chartOptions(dbc.chartType, defaultDataOptions, defaultChartOptions)
						}
				}
                        
				if(chartType=='horizontalBar') {
					if(resp.datasets.length > 9) ctx.height = 300+(resp.datasets.length-9)*30
					else ctx.height = 300;
					ctx.width = 500;
				}

				dbc.chartObj = new Chart(ctx, optionsObject);
				var chart=dbc.chartObj;
				var canvas = document.getElementById('DBChart-' + dbc.id);

				canvas.addEventListener('dblclick', (event) => {fn_tablePopup(event,vc,dbc);});
				
				/*
				const points = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
				let chartYear=vc.m_getChartLocalYear(dbc.id);
				if (points.length > 0 &&dbColumn) {
					var index = points[0]._index;
					var labelValue = chart.data.labels[index];
					var params=`{"${dbColumn}":["${labelValue}"] ${chartYear ? ',"Due Date":' : ""}${chartYear ? '['+chartYear+']' : ""}${dbFilter ? ','+dbFilter : ""}}`;
					var queryParams={"filter":JSON.parse(params)};
					var opts={
							detailView: false,
							pageSize: 5,
							enableSearch: false,
							enableCUFilter: true,
							openLinksInModal: true,
							};
					var visibleCols=["opportunityNo","opportunityName","value","projectSize","clientAccountId","opportunityStatusId","dueDate"];
									
					var p_cols=fn_getColumnsOppr();
					p_cols.forEach(c=>{c.visible=visibleCols.includes(c.field)||c.title==dbColumn;});
					console.log("dashboad p_cols");
					console.log(p_cols);
					vc.d_popupParams={
						p_appEntKey: "oppr",
						p_opts:opts,
						p_cols:p_cols,
						p_tbNote: dbc.name,
						p_tbInfo:dbc.desc,
						p_popupParams: queryParams,
						};
						
					console.log(vc.d_popupParams);
						
				}
			});	
			
			*/
			

				dbc.loading = null;	  
			}					
		})	
	})
}

function fn_getChartLocalYear(chartId){
	var chartLocalYear=window.localStorage.getItem('chart'+chartId+'Year');
	return chartLocalYear?parseInt(chartLocalYear):null;
}

function fn_sortList(rows){
	var selectedRows=rows.filter(r=>r.selected);
	selectedRows.sort((a,b)=>{
			return (a.order > b.order) ? 1 : -1;
			});
	var notSelectedRows=rows.filter(r=>!r.selected);
	notSelectedRows.sort((a,b)=>{
			return (a.name > b.name) ? 1 : -1;
			});
	return [...selectedRows,...notSelectedRows];
	}
	
function fn_tablePopup(event,vc,dbc){
		let chart=dbc.chartObj;
		let dbColumn=dbc.dbColumn;
		let dbFilter =dbc.dbFilter?dbc.dbFilter:null;
		let opts={
					detailView: false,
					pageSize: 5,
					enableSearch: false,
					enableCUFilter: true,
					openLinksInModal: true,
					};
		let visibleCols=["opportunityNo","opportunityName","value","projectSize","clientAccountId","opportunityStatusId","dueDate"];
						
		const points = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);
		let chartYear=vc.m_getChartLocalYear(dbc.id);
		if (points.length > 0 &&dbColumn) {
			var index = points[0]._index;
			var labelValue = chart.data.labels[index];
			var params=`{"${dbColumn}":["${labelValue}"] ${chartYear ? ',"Due Date":' : ""}${chartYear ? '['+chartYear+']' : ""}${dbFilter ? ','+dbFilter : ""}}`;
			var queryParams={"filter":JSON.parse(params)};				
			var p_cols=fn_getColumnsOppr();
			p_cols.forEach(c=>{c.visible=visibleCols.includes(c.field)||c.title==dbColumn;});

			vc.d_popupParams={
					p_appEntKey: "oppr",
					p_opts:opts,
					p_cols:p_cols,
					p_tbNote: dbc.name,
					p_tbInfo:dbc.desc,
					p_popupParams: queryParams,
					};
					
				};

}
</script>

<style scoped lang="less">
#kt-dashboard {
	.kt-dashboard-header {
		display: flex;
		flex-wrap: wrap;

		border-bottom: solid 0.1em #adb5bd;
		padding-bottom: 0.2em;
		margin-bottom: 0.3em;

		> div.dropdown {
			margin: auto 0;
			button.dropdown-toggle {
				//padding: 0em 0.3em;
				padding: 0em;
				margin: auto 0;
			}

			ul.dropdown-menu {
				//padding: 0.5em 0.2em;
				max-height: 300px;
				overflow-y: auto;
				padding: 0em;
			}
			.dropdown-header {
				// text-align: center;
				padding-left: 3em;
			}
			.dropdown-item {
				padding: 0em 0em;
				display: flex;
				border-bottom: solid 0.1em #dee2e6;
				> span {
					width: 150px;
					margin-left: 0.5em;
					.btn-reorder-dashboard {
						cursor: move;
						padding: 0;
					}
				}
				> div {
					display: flex;
					flex-grow: 1;
					padding: 0.2em 0.5em;
					cursor: pointer;
					span {
						margin: auto 0;
					}
					span:nth-child(1) {
						opacity: 0.5;
					}
					span:nth-child(2) {
						padding: 0 0.5em;
					}
					span:nth-child(3) {
						margin-left: auto;
						svg {
							&[data-icon="eye"] {
								color: #4fa4ff;
							}
							&[data-icon="eye-slash"] {
								opacity: 0.4;
							}
						}
					}
					&:hover {
						background-color: #e9ecef;
					}
				}
				&:hover {
					background-color: unset;
				}
				&.sortable-chosen {
					background-color: #e0f0ff;
				}
			}
		}
	}

	.kt-dashboard-content {
		padding: 0.6em 0.3em;
		background-color: #4da4ff18;
		display: flex;
		flex-wrap: wrap;

		div.db {
			position: relative;
			border: solid 0.1em #ced4da;
			box-shadow: 0em 0.1em 0.2em 0.1em #ced4da;
			margin: 5px;
			background-color: #fff;

			&.kt-db-table {
				padding: 0 0.4em;
				max-width: calc(100% - 0.8em);
				> div {
					height: 100%;
					// overflow-y: auto;
				}
				> div > .kt-table {
					height: 100%;
					.kt-toolbar {
						font-size: 0.8em;
						font-weight: bolder;
					}
					.kt-table-table {
						max-height: calc(100% - 75px);
						min-height: 150px;

						table tbody td {
							font-size: 0.95em;
							padding: 0.2em 0.3em;
						}

						.kt-table-aggr {
							background-color: #fff;
							position: sticky;
							bottom: 0;
						}
					}

					.kt-pagination {
						padding: 0;
						font-size: 0.8em;
						div:nth-child(3) a {
							font-size: 0.9em;
							min-width: 15px;
							max-width: 25px;
							padding: 0.1em 0em;
						}
					}
				}

				> div > .resizer-w {
					// border: solid 0.1em blue;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
					cursor: ew-resize;
					opacity: 0.4;
					height: 100%;

					&:hover {
						opacity: unset;
						color: #4fa4ff;
					}
					&::before {
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						right: -10px;
						content: "║";
						font-size: 1.2em;
					}
					&.resizing {
						// border: solid 0.1em blue;
						width: 500px;
						right: -250px;
						z-index: 100;
						&::before {
							right: 240px;
							color: #4fa4ff;
						}
					}
				}
				> div > .resizer-h {
					// border: solid 0.1em blue;
					position: absolute;
					right: 50%;
					bottom: 0;
					transform: translateX(50%);
					cursor: ns-resize;
					opacity: 0.4;
					width: 100%;

					&:hover {
						opacity: unset;
						color: #4fa4ff;
					}
					&::before {
						position: absolute;
						right: 50%;
						transform: translateX(50%);
						top: -10px;
						content: "══";
						font-size: 1.2em;
					}
					&.resizing {
						// border: solid 0.1em blue;
						height: 500px;
						bottom: -250px;
						z-index: 100;
						&::before {
							top: 240px;
							color: #4fa4ff;
						}
					}
				}
			}
			&.kt-db-chart {
				padding: 0.2em;
				// height: 250px;
				width: 360px;
				div.header {
					font-size: 0.85em;
					text-align: left;
					display: flex;
					padding: 0.2em;
					margin-bottom: 0.3em;
					border-bottom: solid 0.1em #ced4da;
					> div:first-child {
						flex-grow: 1;
						> span:first-child {
							font-weight: bolder;
						}

					}

					> div:nth-child(2) {
						margin-right: 0.4em;
						select {
							font-size: 1em;
							option {
								font-size: 0.9em;
							}
						}
					}
					> button {
						font-size: 0.9em;

						&.btn-refresh {
							opacity: 0.5;
							&:hover {
								opacity: unset;
							}
						}
					}
				}

				div.kt-spinner,
				div.chrtMsg {
					position: absolute;
					top: 30%;
					width: 100%;
					font-size: 0.9em;
					text-align: center;
				}

				div.footer {
					div.mnth {
						display: flex;
						justify-content: space-between;
						span.btn {
							font-size: 0.9em;
							padding: 0 0.5em;
						}
					}
				}
			}
		}

		&.tm-filtered {
			div.kt-table .kt-toolbar .btn-cuFilter {
				display: none;
			}
		}
	}

	.none-selected {
		padding-top: 2%;
		min-height: 300px;
		> svg {
			font-size: 1.2em;
			opacity: 0.5;
		}
		ul {
			padding-left: 1.5em;
	}
	}
}
.kt-dashboard-tooltip {
	.tooltip-inner {
		text-align: left;
		max-width: 300px;
	}
}
.dropdown-menu{
    max-height: 300px;
    overflow-y: auto;
}
.btn-reorder-dashboard {
	cursor: move;
	padding: 0;
}
.header-sticky{
	position:sticky;
	top:0px;
	background:white;
	z-index:1;
	}
.header-text{
		text-align:center;
		margin: 0em;
		}
.dropdown-item2 {
				padding: 0em 0em;
				display: flex;
				border-bottom: solid 0.1em #dee2e6;
				> span {
					width: 150px;
					margin-left: 0.5em;
					.btn-reorder-dashboard {
						cursor: move;
						padding: 0;
					}
				}
				> div {
					display: flex;
					flex-grow: 1;
					padding: 0.2em 0.5em;
					cursor: pointer;
					span {
						margin: auto 0;
					}
					span:nth-child(1) {
						opacity: 0.5;
					}
					span:nth-child(2) {
						padding: 0 0.5em;
					}
					span:nth-child(3) {
						margin-left: auto;
						svg {
							&[data-icon="eye"] {
								color: #4fa4ff;
							}
							&[data-icon="eye-slash"] {
								opacity: 0.4;
							}
						}
					}
					&:hover {
						background-color: #e9ecef;
					}
				}
				&:hover {
					background-color: unset;
				}
				&.sortable-chosen {
					background-color: #e0f0ff;
				}
}
.dropdown-item4{
				padding: 0.2em 0.75em;
				display: flex;
				width: 150px;
				}
.topright-close {
  float: right;
  cursor: pointer;
  font-size: 28px;
}
.topright-close:hover {color: red;}
</style>